import {AlertCircleIcon, XCloseIcon} from '@/components/ui/icon/Icon'
import {
    StyledBannerAlertCard,
    StyledBannerAlertTitle,
    StyledBannerAlertDescription,
    StyledBannerAlertWrapper
} from './style'
import {useTheme} from 'styled-components'
import {Button} from '@/components/ui/button/Button'
import {forwardRef} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'

interface BannerAlertProps {
    title?: string
    description?: string
    className?: string
    onClose?: () => void
}

export const BannerAlert = forwardRef<HTMLDivElement, BannerAlertProps>(
    ({title, description, onClose, className}, ref) => {
        const {t} = useTranslation()
        const {palette} = useTheme()

        return (
            <StyledBannerAlertWrapper ref={ref} className={className}>
                <StyledBannerAlertCard gap={2}>
                    <AlertCircleIcon color={palette.danger[600]} size={15} />
                    <Flexbox fullWidth justify="space-between">
                        <Flexbox fullWidth direction="column" gap={0.5}>
                            <StyledBannerAlertTitle>{title || t('commons:error_banner_title')}</StyledBannerAlertTitle>
                            <StyledBannerAlertDescription>
                                {description || t('commons:error_banner_paragraph')}
                            </StyledBannerAlertDescription>
                        </Flexbox>
                        {onClose && (
                            <Button size="sm" variant="ghost" shape="text" onClick={onClose}>
                                <XCloseIcon />
                            </Button>
                        )}
                    </Flexbox>
                </StyledBannerAlertCard>
            </StyledBannerAlertWrapper>
        )
    }
)
